module.exports = __webpack_public_path__ + "static/Inventory-Optimization-84a3c33ad409337a19a36f66586717ac.jpg";